import { create } from 'zustand';
import type { HistoryEntry } from '@core/entities/History';

/**
 * Last response per open tab. Deliberately not persisted (unlike
 * workbenchStore) — response bodies can be large and are cheap to
 * re-fetch/re-send, so they don't belong in localStorage.
 */
interface ResponseState {
  responses: Record<string, HistoryEntry | undefined>;
  sending: Record<string, boolean | undefined>;
  setResponse: (tabKey: string, entry: HistoryEntry) => void;
  setSending: (tabKey: string, isSending: boolean) => void;
  clear: (tabKey: string) => void;
}

export const useResponseStore = create<ResponseState>((set) => ({
  responses: {},
  sending: {},
  setResponse: (tabKey, entry) =>
    set((state) => ({ responses: { ...state.responses, [tabKey]: entry } })),
  setSending: (tabKey, isSending) =>
    set((state) => ({ sending: { ...state.sending, [tabKey]: isSending } })),
  clear: (tabKey) =>
    set((state) => {
      const responses = { ...state.responses };
      delete responses[tabKey];
      return { responses };
    }),
}));
